var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrapWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.4,204.5c-7-22.8-8-50.8-7.3-72.4c0.8-22.5-16.7-43.3-40.4-43.3H132.9c-23.7,0-41.2,20.8-40.4,43.3 c0.8,21.6-0.2,49.6-7.3,72.4c-7.1,22.9-19,37.4-38.5,39.2v21.1c19.5,1.9,31.5,16.3,38.5,39.2c7,22.8,8,50.8,7.3,72.4 c-0.8,22.5,16.7,43.3,40.4,43.3h242.8c23.7,0,41.2-20.8,40.4-43.3c-0.8-21.6,0.2-49.6,7.3-72.4c7.1-22.9,19-37.4,38.5-39.2v-21.1 C442.4,241.8,430.5,227.4,423.4,204.5z M263.3,342.2h-72.4v-176h72c32,0,53,17.3,53,43.9c0,18.7-14.1,35.4-32.1,38.3v1 c24.5,2.7,41,19.6,41,43.1C324.8,323.4,301.6,342.2,263.3,342.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,188.5h-37.2v52.6h31.4c24.2,0,37.6-9.8,37.6-27.2C287.9,197.5,276.4,188.5,256.2,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.9,262h-37v57.9h38.6c25.2,0,38.6-10.1,38.6-29.2C296.1,271.7,282.4,262,255.9,262z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrapWhite);
export default __webpack_public_path__ + "static/media/bootstrap-white.431f2a5c3750204f272b3bd6a42408c6.svg";
export { ForwardRef as ReactComponent };